import React from 'react'
import PublishTopicEditor from './PublishTopicEditor'
import QueryUrlEditor from './QueryUrlEditor'
import TriggerScriptEditor from './TriggerScriptEditor'

const registry = {
  [PublishTopicEditor.TYPE] : PublishTopicEditor,
  [QueryUrlEditor.TYPE] : QueryUrlEditor,
  [TriggerScriptEditor.TYPE] : TriggerScriptEditor
}

const defaults = {
  [PublishTopicEditor.TYPE] : PublishTopicEditor.DEFAULTS,
  [QueryUrlEditor.TYPE] : QueryUrlEditor.DEFAULTS,
  [TriggerScriptEditor.TYPE] : TriggerScriptEditor.DEFAULTS
}

function createTimerAction( timerAction, props ) {
  let ActionObj
  if ( timerAction.type === PublishTopicEditor.TYPE && timerAction.topic === 'reason' ) {
    ActionObj = TriggerScriptEditor
  } else {
    ActionObj = registry[timerAction.type]
  }
  return <ActionObj action={timerAction} {...props} /> 
}

exports.createEditor = createTimerAction
exports.registry = registry
exports.defaults = defaults
exports.PublishTopicEditor = PublishTopicEditor
exports.QueryUrlEditor = QueryUrlEditor
